<template>
    <div class="web-search dsp-flex">
        <div class="web-search-left dsp-flex">
            <div class="web-search-icon"><i class="iconfont icon-search"></i></div>
            <input class="web-search-input" v-model="searchPediaText" type="text" placeholder="搜索" @keyup="inputKeyup($event)" >
        </div>
        <div class="web-search-middle" @click="clickSearch">寻找名人八字</div>
        <div class="web-search-right"><button @click="clickCreate">录入名人</button></div>
    </div>
</template>

<script>
export default {
    name: 'WebSearchInput',
    computed: {
        searchPediaText: {
            get() {
                return this.$store.state.famouspedia.searchPediaText;
            },
            set(value) {
                this.$store.state.famouspedia.searchPediaText = value;
            }
        }
    },
    methods: {
        inputKeyup(el) {
            var me = this;
            if(el.keyCode == 13 && this.searchPediaText != '') {
                this.clickSearch();
            }
        },
        clickSearch() {
            var me = this;
            if(this.searchPediaText != '') {
                this.$store.dispatch('famouspedia/getBaikeSearchResult', {
                    text: this.searchPediaText,
                    cb: function(listData) {
                        if(listData.length > 0) {
                            me.initBaikeInfo(listData[0]);
                        }else {
                            me.$router.replace('/webnoresult')
                            me.$bus.emit('updateWebNoResult')
                        }
                    }
                })
            }
        },
        initBaikeInfo(data) {
            var me = this;

            this.$store.dispatch('comment/resetData');
            this.$store.dispatch('minifatefortune/resetMiniData');
            this.$store.dispatch('famouspediacomment/resetData');
            this.$store.dispatch('famouspedia/resetPediaData');
            this.$store.dispatch('famouspedia/initBaikeInfo', {
                fromDetail: false,
                baikeId: data.id,
                baikeType: data.type,
                baikeStatus: data.f_status,
                sucCb: function() {
                    me.$router.replace('/famouspediareadweb/' + data.id + '/famouspedia')
                },

            });
        },
        clickCreate() {
            this.$store.dispatch('collate/initSizhuCollate');
            this.$router.replace('/famouspediacreate')
        }
    }
}
</script>